import {Component, OnInit} from '@angular/core';
import {PrimeNGConfig} from 'primeng/api';
import { Router, NavigationEnd } from '@angular/router';
import * as AOS from 'aos';
import { GeoLocationService } from "./services/geo-location.service";
import { environment } from 'src/environments/environment';
const bannedStateList = environment.bannedStateList
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
    menuMode = 'sidebar';

    darkMode = 'light';

    topbarTheme = 'light';

    menuTheme = 'light';

    inputStyle = 'outlined';

    ripple: boolean;

    constructor(private primengConfig: PrimeNGConfig,private router: Router, private geoLocationService:GeoLocationService) {
      this.geoLocationService.fetchAndSetGeoLocation()

     }

    ngOnInit() {
      AOS.init();
        this.primengConfig.ripple = true;
        this.router.events.subscribe((evt) => {
          if (!(evt instanceof NavigationEnd)) {
              return;
          }
          window.scrollTo(0, 0)
      });
    }

}
